var map = {
	"./Bootstrap.png": 35,
	"./C#.png": 36,
	"./CSS3.png": 37,
	"./Firebase.png": 38,
	"./Git.png": 39,
	"./HTML5.png": 40,
	"./JSON.png": 41,
	"./JavaScript.png": 42,
	"./NodeJS.png": 43,
	"./ReactJS.png": 44,
	"./Sass.png": 45,
	"./TypeScript.png": 46,
	"./jQuery.png": 47,
	"./mongoDB.png": 48,
	"./python.png": 49,
	"./webpack.png": 50
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;


//////////////////
// WEBPACK FOOTER
// ./src/components/TechSkills/icons ^\.\/.*\.png$
// module id = 34
// module chunks = 0